import { Configuration } from '~/core/configuration/configuration.type';
import { handleNativeSearchAnalytics } from './handleNativeSearchAnalytics';

const AB_TESTING_COOKIE_NAME = 'a_b_test';

const getCookie = (name: string): string | undefined => {
    const cookie = document.cookie.split('; ').find((row) => row.startsWith(name));

    if (cookie) {
        return cookie.split('=')[1];
    }
};

/**
 * Reads the cookie and returns either true if SERP should be rendered or false if SERP should not be rendered
 * also if false is the case, it will register analytics for native search events
 * if there is no cookie, it will proceed with the default behaviour
 */
export const handleABTesting = (configuration: Configuration): boolean => {
    // if A/B Testing is not enabled, or the configuration for A/B Testing is not set at all, proceed with the default behaviour
    if (!configuration.layout.configuration.ABTesting || !configuration.layout.configuration.ABTesting.enabled) {
        return true;
    }

    // if A/B Testing is enabled, try to read the cookie
    const cookie = getCookie(AB_TESTING_COOKIE_NAME);

    // if cookie is set to B, do not render SERP and register analytics for native search events
    if (cookie && cookie === 'B') {
        handleNativeSearchAnalytics(configuration);
        return false;
    }

    return true;
};
